<h2 mat-dialog-title>Add New Requestor</h2>

<mat-dialog-content class="dialog-content">
  <p class="dialog-description">Add a new requestor to the system. This person will be available for selection in future events.</p>
  
  <form [formGroup]="requestorForm" class="requestor-form">
    
    <!-- Name Field -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Full Name *</mat-label>
      <input matInput 
             formControlName="name" 
             placeholder="Enter full name"
             autocomplete="name">
      <mat-error *ngIf="requestorForm.get('name')?.hasError('required')">
        Name is required
      </mat-error>
      <mat-error *ngIf="requestorForm.get('name')?.hasError('minlength')">
        Name must be at least 2 characters
      </mat-error>
    </mat-form-field>

    <!-- Email Field -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Email Address *</mat-label>
      <input matInput 
             formControlName="email" 
             type="email"
             placeholder="Enter email address"
             autocomplete="email">
      <mat-error *ngIf="requestorForm.get('email')?.hasError('required')">
        Email is required
      </mat-error>
      <mat-error *ngIf="requestorForm.get('email')?.hasError('email')">
        Please enter a valid email address
      </mat-error>
    </mat-form-field>

    <!-- Department Field -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Department</mat-label>
      <input matInput 
             formControlName="department" 
             placeholder="Enter department (optional)"
             autocomplete="organization">
    </mat-form-field>

    <!-- Title Field -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Job Title</mat-label>
      <input matInput 
             formControlName="title" 
             placeholder="Enter job title (optional)"
             autocomplete="organization-title">
    </mat-form-field>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button (click)="cancel()" type="button">
    Cancel
  </button>
  <button mat-flat-button 
          color="primary" 
          (click)="saveRequestor()" 
          [disabled]="requestorForm.invalid"
          type="submit">
    <mat-icon>person_add</mat-icon>
    Add Requestor
  </button>
</mat-dialog-actions>
